import { RagAuthGate } from "@/apps/rag/components/RagAuthGate.js";

export function RegulatoryLayout() {
  return <RagAuthGate />;
}
